import React from "react";
import _ from "lodash";
import {
  sessionExpired,
  messageRefreshInterval,
  serverUrl,
} from "../config/GeneralConfig";
import {
  setMessageStatus,
  getConversation,
  updateMessage,
  sendMessage,
  unsuspenduser,
} from "../modules/MessageManager";
import {
  showSpinner,
  closeSpinner,
  modal,
  alert,
  adminModerateMessage,
  adminEditMessage,
} from "../modules/Dialogs";
import { toScreen, goBack } from "../modules/Routing";
import bookingIcon from "../../icons/box-14.png";
import PropTypes from "prop-types";
import withNavigate from "./withNavigate";
import { io } from "socket.io-client";
import SuspensionModal from "./SuspensionModal";
class Message extends React.Component {
  constructor(props) {
    super(props);

    this.getConversation = this.getConversation.bind(this);
    this.getConversation_done = this.getConversation_done.bind(this);
    this.setConversationReadStatus = this.setConversationReadStatus.bind(this);
    this.setConversationReadStatus_done =
      this.setConversationReadStatus_done.bind(this);
    this.moderateMessage = this.moderateMessage.bind(this);
    this.updateMessage = this.updateMessage.bind(this);
    this.updateMessage_done = this.updateMessage_done.bind(this);
    this.renderMessages = this.renderMessages.bind(this);
    this.sendMessage = this.sendMessage.bind(this);
    this.discardMessage = this.discardMessage.bind(this);
    this.sendMessage_done = this.sendMessage_done.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFetchunSuspendUser = this.handleFetchunSuspendUser.bind(this);
    this.extraAttributes = window.history.state.usr;
    if (this.extraAttributes) {
      this.joinRoomPayload = {
        receiverId: this.extraAttributes?.receiverId,
        receiverShortId: this.extraAttributes?.receiverShortId,
        receiverType: this.extraAttributes?.receiverType,
      };
    } else {
      this.joinRoomPayload = null;
    }
    this.nextPage = this.nextPage.bind(this);
    this.prevPage = this.prevPage.bind(this);

    this.state = {
      updateOnUnmount: {
        messages: false,
      },
      _id: "",
      short_id: "",
      conversation: {},
      messages: {},
      newMessage: "",
      pagination: {
        page: 1,
        total: 1,
      },
      pageSize: 10,
      suspendData: this.extraAttributes?.suspendData || null,
      suspensionModalData: null,
    };
    this.state.socket = null;
  }
  setConversationReadStatus() {
    if (this.state._id && this.state._id != "") {
    }
    var theConversation = {
      accountInfo: {
        username: this.props.userDetails.accountInfo.username,
        email: this.props.userDetails.accountInfo.email,
      },
      conversation: this.state.short_id,
      message: "",
      readStatus: "read",
    };

    // setMessageStatus(
    //   theConversation,
    //   this.setConversationReadStatus_done,
    //   this.props.userDetails.jwttoken
    // );
  }

  setConversationReadStatus_done(resStatus, responseString, resJson) {
    if (resStatus == 401) {
      modal(sessionExpired);
      toScreen(false, this.props.navigate, "/logout");
    } else if (resStatus == "400") {
    } else if (resStatus == 200) {
      this.setState({
        ...this.state,
        updateOnUnmount: {
          ...this.state.updateOnUnmount,
          messages: true,
        },
        messages: resJson.messages,
      });
    }
  }

  getConversation(event) {
    if (this.state.short_id == "") {
      showSpinner();
    }
    if (event) {
      event.preventDefault();
    }

    // const theUser = {
    //   accountInfo: {
    //     username: this.props.userDetails.accountInfo.username,
    //     email: this.props.userDetails.accountInfo.email,
    //   },
    // };
    // theUser.participants = JSON.stringify([
    //   this.extraAttributes.userShortId1 === "admin"
    //     ? "Admin"
    //     : this.extraAttributes.userShortId1,
    //   this.extraAttributes.userShortId2,
    // ]);

    const queryParams = {
      receiverShortId: this.extraAttributes.receiverShortId || "",
      receiverId: this.extraAttributes.receiverId || "",
      requasterShortId:
        this.extraAttributes.userShortId1 === "admin"
          ? "Admin"
          : this.extraAttributes.userShortId1 || "",
      page: this.state.pagination.page,
      pageSize: this.state.pageSize,
    };
    getConversation(
      queryParams,
      this.getConversation_done,
      this.props.userDetails.jwttoken
    );
  }

  getConversation_done(resStatus, responseString, resJson) {
    closeSpinner();
    if (resStatus == 401) {
      modal(responseString, "401 Unauthorized", () => window.history.back());
    } else if (resStatus == "400") {
      modal(responseString, "Something went wrong!", () => window.history.back());
    } else if (resStatus == 200) {
      const inputChangeCallback = () => {
        this.setConversationReadStatus();
      };


      if (
        !_.isEqual(resJson?.data?.messages, this.state.conversation) ||
        !_.isEqual(resJson?.data?.participants, this.state.participants)
      ) {
        this.setState(
          {
            ...this.state,
            short_id: resJson?.data?.short_id,
            conversation:
              (resJson?.data?.messages &&
                Object?.values(resJson?.data?.messages)) ||
              [],
            participants: resJson?.data?.participants || [],
            pagination: {
              ...this.state.pagination,
              total: Math.ceil(resJson?.totalRecords / this.state.pageSize),
            },
          },
          inputChangeCallback
        );
      }
      //** COMMENTED for no need to call conversation api every 5 seconds */
      // if (!this.interval) {
      // 	this.interval = setInterval(() => {
      // 		this.getConversation();
      // 	}, messageRefreshInterval);
      // }
    }
  }

  updateMessage(event, key) {
    // CLEAR INTERVAL HERE

    if (event) {
      event.preventDefault();
    }

    if (this.state.conversation[key]) {
      var theMessage = {
        conversation_short_id: this.state.short_id,
        message: {
          _id: this.state.conversation[key]._id,
          message: this.state.conversation[key].message,
          moderation: {
            flags:
              this.state.conversation[key].moderation &&
                this.state.conversation[key].moderation.flags
                ? this.state.conversation[key].moderation.flags
                : "",
            moderatorMessage:
              this.state.conversation[key].moderation &&
                this.state.conversation[key].moderation.moderatorMessage
                ? this.state.conversation[key].moderation.moderatorMessage
                : "",
            status:
              this.state.conversation[key].moderation &&
                this.state.conversation[key].moderation.status
                ? this.state.conversation[key].moderation.status
                : "",
          },
        },
      };

      updateMessage(
        theMessage,
        this.updateMessage_done,
        this.props.userDetails.jwttoken
      );
    }
  }

  updateMessage_done(resStatus, responseString, resJson) {
    // REASTART INTERVAL HERE

    if (resStatus == 401) {
      modal(sessionExpired);
      toScreen(false, this.props.navigate, "/logout");
    } else if (resStatus == "400") {
      modal(responseString);
    } else if (resStatus == 200) {
      //modal('Message successfully updated');
      closeSpinner();
      this.getConversation(false);
    }
  }

  moderateMessage(event, key) {
    if (event) {
      event.preventDefault();
    }

    if (this.state.conversation[key].userType != "admin") {
      var editMessage = { ...this.state.conversation[key] };

      const approveMessageCallback = () => {
        showSpinner();
        this.setState(
          {
            ...this.state,
            conversation: {
              ...this.state.conversation,
              [key]: {
                ...this.state.conversation[key],
                moderation: {
                  ...this.state.conversation[key].moderation,
                  status: "approved",
                },
              },
            },
          },
          () => {
            this.updateMessage(false, key);
          }
        );
      };

      const rejectMessageCallback = () => {
        showSpinner();
        this.setState(
          {
            ...this.state,
            conversation: {
              ...this.state.conversation,
              [key]: {
                ...this.state.conversation[key],
                moderation: {
                  ...this.state.conversation[key].moderation,
                  status: "rejected",
                },
              },
            },
          },
          moderatorMessageCallback
        );
      };

      const saveMessageCallback = (theMode, theMessage, theModerateMessage) => {
        showSpinner();
        this.setState(
          {
            ...this.state,
            conversation: {
              ...this.state.conversation,
              [key]: {
                ...this.state.conversation[key],
                message:
                  theMode == "edit"
                    ? theMessage
                    : this.state.conversation[key].message,
                moderation: {
                  ...this.state.conversation[key].moderation,
                  status: theMode == "reject" ? "rejected" : "edited",
                  moderatorMessage: theModerateMessage || "",
                },
              },
            },
          },
          () => {
            this.updateMessage(false, key);
          }
        );
      };

      const editMessageCallback = () => {
        adminEditMessage(
          this.state.conversation[key],
          saveMessageCallback,
          "edit",
          this.state.participants
        );
      };

      const moderatorMessageCallback = () => {
        adminEditMessage(
          this.state.conversation[key],
          saveMessageCallback,
          "reject",
          this.state.participants
        );
      };
      adminModerateMessage(
        this.state.conversation[key],
        approveMessageCallback,
        rejectMessageCallback,
        editMessageCallback,
        this.state.participants
      );
    }
  }

  renderMessages(key) {
    //u-cursor-pointer
    const message = this.state.conversation[key];
    const isClientsChat = message.userType === "user";
    const isAdminChat = message.userType === "admin";
    const printFlags = (theFlags) => {
      var flagString = " (";

      _.forEach(theFlags, function (value) {
        if (!flagString || flagString == " (") {
          flagString += '"' + value + '"';
        } else {
          flagString += ', "' + value + '"';
        }
      });

      flagString += " )";

      return flagString;
    };
    const matchingParticipant = this.state.participants.find(
      (participant) => participant.user === message.user
    );
    // return (
    //   <>
    //     <div
    //       key={key}
    //       className={`msg ${isClientsChat ? "right-msg" : "left-msg"}`}
    //     >
    //       <div
    //         className="msg-bubble"
    //         onClick={(e) => {
    //           this.moderateMessage(e, key);
    //         }}
    //       >
    //         <div className="msg-info">
    //           <div className="msg-info-name">
    //             <span
    //               className={!isAdminChat && "u-cursor-pointer"}
    //               onClick={(e) => {
    //                 if (message.userType !== "admin") {
    //                   toScreen(
    //                     e,
    //                     this.props.navigate,
    //                     message.userType === "user"
    //                       ? `/client/${this.extraAttributes.userShortId2}`
    //                       : message.userType === "mav"
    //                       ? `/mav/${this.extraAttributes.userShortId1}`
    //                       : null,
    //                     false,
    //                     this.extraAttributes
    //                   );
    //                 }
    //               }}
    //             >
    //               {isAdminChat
    //                 ? "Admin"
    //                 : message.user?.accountInfo?.username ??
    //                   this.extraAttributes.username2}
    //             </span>

    //             <span className="disputeLable">
    //               {message.disputeFlag &&
    //               message.disputedJob_short_id &&
    //               message.disputedJob_short_id != "" ? (
    //                 <button
    //                   onClick={(e) =>
    //                     toScreen(
    //                       e,
    //                       this.props.navigate,
    //                       `/job/${message.disputedJob_short_id}`
    //                     )
    //                   }
    //                 >
    //                   <i className="u-font-size-12 u-color-red">
    //                     Disputing job: {message.disputedJob_short_id}
    //                   </i>
    //                 </button>
    //               ) : null}
    //             </span>

    //             <span className="quoteInfoLable">
    //               {message.associatedQuoteShortID &&
    //               message.associatedQuoteShortID != "" ? (
    //                 <i className="u-font-size-12">
    //                   &nbsp;Message about quote :{" "}
    //                   {message.associatedQuoteShortID}
    //                 </i>
    //               ) : null}
    //             </span>
    //             {message?.moderation?.status != "" &&
    //               message?.moderation?.status != "approved" && (
    //                 <>
    //                   {message.moderation.status == "flagged" && (
    //                     <span className="u-before-icon-exclamation u-color-red">
    //                       &nbsp;Flagged message{" "}
    //                       {message.moderation.flags &&
    //                       _.size(message.moderation.flags) > 0
    //                         ? printFlags(message.moderation.flags)
    //                         : null}
    //                     </span>
    //                   )}

    //                   {message.moderation.status == "rejected" && (
    //                     <span className="u-before-icon-exclamation">
    //                       &nbsp;Rejected message
    //                     </span>
    //                   )}

    //                   {message.moderation.status == "edited" && (
    //                     <span className="u-before-">&nbsp;Edited message</span>
    //                   )}
    //                   {message?.moderation?.moderatorMessage != "" && (
    //                     <span className="c-message-moderation-moderatorcomment">
    //                       "{message?.moderation?.moderatorMessage}"
    //                     </span>
    //                   )}
    //                 </>
    //               )}
    //           </div>
    //           <div className="msg-info-time">
    //             {message?.time} on {message?.date}
    //           </div>
    //         </div>
    //         <div className="msg-text">{message?.message}</div>
    //       </div>
    //     </div>
    //   </>
    // );

    if (message.messageType === "booking") {
      const bookingNames = {
        user: [
          this.state.participants?.find((p) => p.accountInfo?.userType === "user")?.accountInfo?.firstname,
          this.state.participants?.find((p) => p.accountInfo?.userType === "user")?.accountInfo?.lastname,
        ].filter(Boolean).join(" "),
        driver: [
          this.state.participants?.find((p) => p.accountInfo?.userType === "mav")?.accountInfo?.firstname,
          this.state.participants?.find((p) => p.accountInfo?.userType === "mav")?.accountInfo?.lastname,
        ].filter(Boolean).join(" "),
      };

      return (
        <div key={key} className="c-booking-card">
          <img className="c-booking-card__icon" src={bookingIcon} alt="" />
          <div className="c-booking-card__heading">A booking has been made</div>
          <div className="c-booking-card__body">
            {bookingNames.driver && (
              <div>
                <b>Driver:</b> {bookingNames.driver}
              </div>
            )}
            {bookingNames.user && (
              <div>
                <b>User:</b> {bookingNames.user}
              </div>
            )}
           
            {message.associatedQuoteShortID && (
              <div>
                <b>Quote ID:</b>{" "}
                <span className="u-uppercase">{message.associatedQuoteShortID}</span>
              </div>
            )}
            {message.associatedJobShortID && (
              <div>
                <b>Job ID:</b>{" "}
                <span className="u-uppercase">{message.associatedJobShortID}</span>
              </div>
            )}
            {message.associatedQuotePrice !== undefined &&
              message.associatedQuotePrice !== null && (
                <div>
                  <b>Price:</b> £{message.associatedQuotePrice}
                </div>
              )}
          </div>
          <div className="c-booking-card__time u-font-size-12">
            {message.time} on {message.date}
          </div>
        </div>
      );
    }
    if (this.extraAttributes.userShortId1 !== "admin") {
      return (
        <div key={key}>
          <div
            onClick={(e) => {
              this.moderateMessage(e, key);
            }}
            className={
              message.userType === "admin" ||
                (this.extraAttributes.userShortId2 && message.userType === "mav")
                ? message.moderation &&
                  message.moderation.status &&
                  message.moderation.status != "" &&
                  message.moderation.status == "rejected"
                  ? "c-message-bubble c-message-bubble--rejected u-margin-bottom-0 u-cursor-pointer"
                  : "c-message-bubble u-margin-bottom-0 u-cursor-pointer"
                : message.moderation &&
                  message.moderation.status &&
                  message.moderation.status != "" &&
                  message.moderation.status == "rejected"
                  ? "c-message-bubble c-message-bubble--user c-message-bubble--rejected u-margin-bottom-0 u-cursor-pointer"
                  : "c-message-bubble c-message-bubble--user u-margin-bottom-0 u-cursor-pointer"
            }
          >
            <div className="c-message-bubble__copy left-chat">
              <b
                className="u-font-size-12 text-capitalize"
                onClick={(e) => {
                  if (message?.userType === "mav" || message?.userType === "user") {
                    toScreen(
                      e,
                      this.props.navigate,
                      message.userType === "user"
                        ? `/client/${message?.user_short_id}`
                        : message.userType === "mav"
                          ? `/mav/${message?.user_short_id}`
                          : null,
                      false,
                      this.extraAttributes
                    );
                  }
                }}
              >

                {message?.userType === "admin"
                  ? "Admin"
                  : matchingParticipant?.accountInfo?.username || ""}
              </b>
              {message.disputeFlag &&
                message.disputedJob_short_id &&
                message.disputedJob_short_id != "" ? (
                <i className="u-font-size-12 u-color-red">
                  &nbsp;Disputing job: {message.disputedJob_short_id}
                </i>
              ) : null}
              {message.associatedQuoteShortID &&
                message.associatedQuoteShortID != "" ? (
                <i className="u-font-size-12">
                  &nbsp;Message about quote :{" "}
                  <span className="u-uppercase">
                    {message.associatedQuoteShortID}
                  </span>
                </i>
              ) : null}
              <br />
              <span
                className={
                  message.moderation &&
                    message.moderation.status &&
                    message.moderation.status != "" &&
                    message.moderation.status == "flagged"
                    ? "u-color-red"
                    : null
                }
              >
                {message.message}
              </span>
            </div>
            <div>
              <div className="c-message-bubble__time u-font-size-12">
                {message.time} on {message.date}
              </div>
            </div>
          </div>
          <div
            className={
              message.userType === "admin" ||
                (this.extraAttributes.userShortId2 && message.userType === "mav")
                ? "c-message-moderation"
                : "c-message-moderation c-message-moderation--user"
            }
          >
            {message?.moderation?.status != "" &&
              message.moderation.status != "approved" && (
                <div className="c-message-moderation__copy">
                  {message.moderation.status == "flagged" && (
                    <span className="u-before-icon-exclamation u-color-red">
                      &nbsp;Flagged message{" "}
                      {message.moderation.flags &&
                        _.size(message.moderation.flags) > 0
                        ? printFlags(message.moderation.flags)
                        : null}
                      <br />
                    </span>
                  )}
                  {message.moderation.status == "rejected" && (
                    <span className="u-before-icon-exclamation">
                      &nbsp;Rejected message
                      <br />
                    </span>
                  )}
                  {message.moderation.status == "edited" && (
                    <span className="u-before-">
                      &nbsp;Edited message
                      <br />
                    </span>
                  )}
                  {message.moderation.moderatorMessage &&
                    message.moderation.moderatorMessage != "" && (
                      <span className="c-message-moderation-moderatorcomment">
                        "{message.moderation.moderatorMessage}"
                      </span>
                    )}
                </div>
              )}
          </div>
        </div>
      );
    } else {
      return (
        <div key={key}>
          <div
            className={`c-message-bubble ${(message?.userType === "mav" || message?.userType === "user") &&
              "c-message-bubble--user"
              } ${message?.moderation?.status == "rejected" &&
                message?.userType === "admin"
                ? "c-message-bubble--rejected"
                : "c-message-bubble--user--rejected"
              }`}
          // className={
          //   message.userType === "admin" ||
          //   (this.extraAttributes.userShortId2 && message.userType === "mav")
          //     ? message.moderation &&
          //       message.moderation.status &&
          //       message.moderation.status != "" &&
          //       message.moderation.status == "rejected"
          //       ? "c-message-bubble c-message-bubble--rejected"
          //       : "c-message-bubble"
          //     : message.moderation &&
          //       message.moderation.status &&
          //       message.moderation.status != "" &&
          //       message.moderation.status == "rejected"
          //     ? "c-message-bubble c-message-bubble--user c-message-bubble--user--rejected"
          //     : "c-message-bubble c-message-bubble--user"
          // }
          >
            <div className="c-message-bubble__copy">
              <b
                className={`u-font-size-12 text-capitalize ${message.userType !== "admin" && "u-cursor-pointer"
                  }`}
                onClick={(e) => {
                  if (message.userType === "user" || message.userType === "mav") {
                    toScreen(
                      e,
                      this.props.navigate,
                      `/${message?.userType === "user"
                        ? "client"
                        : message.userType
                      }/${message?.user_short_id}`,
                      // message.userType === "user"
                      //   ? `/client/${this.extraAttributes.userShortId2}`
                      //   : message.userType === "mav"
                      //   ? `/mav/${this.extraAttributes.userShortId1}`
                      //   : null,
                      false,
                      this.extraAttributes
                    );
                  }
                }}
              >

                {message?.userType === "admin"
                  ? "Admin"
                  : matchingParticipant?.accountInfo?.username || ""}
              </b>{" "}
              {message.disputeFlag &&
                message.disputedJob_short_id &&
                message.disputedJob_short_id != "" ? (
                <button
                  onClick={(e) =>
                    toScreen(
                      e,
                      this.props.navigate,
                      `/job/${message.disputedJob_short_id}`
                    )
                  }
                >
                  <i className="u-font-size-12 u-color-red">
                    Disputing job:{" "}
                    <span className="u-uppercase">
                      {message.disputedJob_short_id}
                    </span>
                  </i>
                </button>
              ) : null}
              <br />
              <span
                className={
                  message.moderation &&
                    message.moderation.status &&
                    message.moderation.status != "" &&
                    message.moderation.status == "flagged"
                    ? "u-color-red"
                    : null
                }
              >
                {message.message}
              </span>
            </div>
            <div>
              <div className="c-message-bubble__time u-font-size-12">
                {message.time} on {message.date}
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

  sendMessage(event) {
    if (this.state?.newMessage) {
      showSpinner();

      //**----------Send Message Without SOCKET--------*/
      const receiverId = this.state?.participants
        ?.filter((item) => item?.user_short_id !== "Admin" && item?.user)
        ?.map((item) => item?.user)
        ?.join("");
      const requestBody = {
        conversationShortId: this.state?.short_id || "",
        receiverId: receiverId || "",
        messageType: "conversation",
        message: this.state?.newMessage,
      };
      sendMessage(
        requestBody,
        this.sendMessage_done,
        this.props?.userDetails?.jwttoken
      );
      //**----------END Send Message Without SOCKET--------*/

      //**----------Send Message By SOCKET--------*/
      // if (event) {
      //   event.preventDefault();
      // }
      // const sendMessagePayloads = {
      //   ...this.joinRoomPayload,
      //   conversationShortId: this.state.short_id,
      //   messageType: "conversation",
      //   message: this.state?.newMessage,
      // };
      // if (this.socket?.connected) {
      //   this.socket.emit("send-message", sendMessagePayloads);
      //   this.socket.on(
      //     `send-message-error-${this.props.userDetails.short_id}`,
      //     (sendMessageErrorResp) => {
      //       if (sendMessageErrorResp) {
      //         modal(`ERROR: ${sendMessageErrorResp}`, "Something went wrong!"),
      //           closeSpinner();
      //       }
      //     }
      //   );
      //   let updatedConversations = this.state.conversation
      //   updatedConversations.push({message: this.state?.newMessage,
      //     date: new Date().toISOString().split('T')[0],
      //     time: new Date().toTimeString().split(' ')[0].slice(0, 5),
      //     userType: "admin"})
      //   this.setState({
      //     ...this.state,
      //     conversation: updatedConversations,
      //   });
      //   this.discardMessage()
      //   // this.setState({...this.state,conversation: {
      //   //   message: this.state?.newMessage,
      //   //   date: new Date().toISOString().split('T')[0],
      //   //   time: new Date().toTimeString().split(' ')[0].slice(0, 5),
      //   //   userType: "admin"
      //   // }})
      //   closeSpinner();
      // }
      // closeSpinner();

      //**----------END Send Message By SOCKET--------*/

    } else {
      modal("Please enter the message");
    }
  }

  sendMessage_done(resStatus, responseString, resJson) {
    if (resStatus == 401) {
      modal("Please try again", "Something went wrong!");
    } else if (resStatus == 400) {
      modal(responseString);
      closeSpinner();
    } else if (resStatus == 200) {
      this.setState(
        {
          ...this.state,
          newMessage: "",
          pagination: {
            ...this.state.pagination,
            page: 1,
          },
        },
        () => {
          closeSpinner();
          this.getConversation();
        }
      );
    }
  }

  discardMessage(event) {
    if (event) {
      event.preventDefault();
    }

    this.setState(
      {
        newMessage: "",
      }
      // () => {
      // 	goBack(false, this.props.navigate);
      // }
    );
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    if (name.split(".").length == 1) {
      this.setState({
        [name]: value,
      });
    } else if (name.split(".").length == 2) {
      this.setState({
        [name.split(".")[0]]: {
          ...this.state[name.split(".")[0]],
          [name.split(".")[1]]: value,
        },
      });
    }
  }

  nextPage(event) {
    if (event) {
      event.preventDefault();
    }

    const inputChangeCallback = () => {
      this.getConversation();
    };

    if (this.state.pagination.page < this.state.pagination.total) {
      showSpinner();
      this.setState(
        {
          ...this.state,
          pagination: {
            ...this.state.pagination,
            page: this.state.pagination.page + 1,
          },
        },
        inputChangeCallback
      );
    }
  }
  prevPage(event) {
    if (event) {
      event.preventDefault();
    }

    const inputChangeCallback = () => {
      this.getConversation();
    };

    if (this.state.pagination.page > 1) {
      showSpinner();
      this.setState(
        {
          ...this.state,
          pagination: {
            ...this.state.pagination,
            page: this.state.pagination.page - 1,
          },
        },
        inputChangeCallback
      );
    }
  }

  handleFetchunSuspendUser({ userId, userName, offenseDetailId, decision, userType, reason }) {
    showSpinner();
    const payload = { userId, offenseDetailId, decision, userType, reason };
    unsuspenduser(payload, (resStatus, responseString, resJson) => {
      closeSpinner();
      if (resStatus === 200) {
        const statusText = decision === "suspended" ? "Suspended" : "Unsuspended";
        this.setState({
          suspendData: {
            ...this.state.suspendData,
            isSuspended: decision === "suspended",
          },
          suspensionModalData: {
            userName,
            userType,
            statusText,
            reason: reason || "No reason provided",
            message: resJson?.message,
            decision,
          },
        });
      } else if (resStatus === 400) {
        modal(responseString);
      } else {
        modal(responseString, "Something went wrong!");
      }
    }, this.props.userDetails.jwttoken);
  }

  componentWillMount() {
    // this.socket = io(`${serverUrl}`, {
    //   transports: ["websocket"],
    //   auth: {
    //     token: `Bearer ${this.props?.userDetails?.jwttoken}`,
    //   },
    //   reconnectionAttempts: 5,
    //   timeout: 20000,
    // });
  }
  componentDidMount() {
    this.getConversation();

    //** FETCH CONVERSATION BY SOCKET */

    // if (this.extraAttributes.userShortId1 === "admin") {
    //   showSpinner();
    //   if (this.joinRoomPayload) {
    //     this.socket.on("connect", async () => {
    //       this.socket.emit("join-room", this.joinRoomPayload);
    //       this.socket.on(
    //         `join-room-error-${this.props.userDetails.short_id}`,
    //         (errorJoinRoomResp) => {
    //           if (errorJoinRoomResp) {
    //             modal(`ERROR: ${errorJoinRoomResp}`, "Something went wrong!");
    //             this.setState({
    //               ...this.state,
    //               short_id: "",
    //               conversation: [],
    //               participants: [],
    //             });
    //             closeSpinner();
    //           }
    //         }
    //       );
    //       this.socket.on("conversation", (conversationResp) => {
    //         if (conversationResp) {
    //           this.setState({
    //             ...this.state,
    //             short_id: conversationResp?.short_id ?? "",
    //             conversation: conversationResp?.messages ?? [],
    //             participants: conversationResp?.participants ?? [],
    //           });
    //           closeSpinner();
    //         }
    //       });
    //     });
    //     this.socket.on("connection-error", (err) => {
    //       modal("Connection timeout, reload the page");
    //       closeSpinner();
    //     });
    //   } else {
    //     closeSpinner();
    //   }
    // } else {
    //   this.getConversation();
    // }
  }

  componentWillUnmount() {
    if (this.socket?.connected) {
      this.socket.emit("leave-room", { conversationId: this.state?.short_id });
      this.socket.disconnect();
    }

    if (this.interval) {
      clearInterval(this.interval);
    }
    if (this.state.updateOnUnmount.messages) {
      const userDetails = {
        ...this.props.userDetails,
        messages: this.state.messages,
      };

      this.props.updateState("userDetails", userDetails);
    }
  }

  componentDidUpdate() {
    if (this.socket?.connected) {
      this.socket.on("new-message", (recentMessage) => {
        if (recentMessage) {
          let userReceivedMsg = [...this.state.conversation];
          userReceivedMsg.push(recentMessage);
          this.setState({ conversation: userReceivedMsg });
          this.discardMessage();
        }
      });
    }
  }
  renderPaginaiton = () => {
    return (
      <div className="c-pagination">
        <button
          type="button"
          className="c-pagination__prev"
          onClick={(e) => this.prevPage(e)}
        >
          &lt;&lt; Prev
        </button>
        {this.state.conversation.length > 0 && (
          <span>
            {this.state.pagination.page} / {this.state.pagination.total}
          </span>
        )}
        <button
          type="button"
          className="c-pagination__next"
          onClick={(e) => this.nextPage(e)}
        >
          Next &gt;&gt;
        </button>
      </div>
    );
  };
  render() {
    return (
      <div className="l-base-layout__content">
        {this.state.suspensionModalData && (
          <SuspensionModal
            userName={this.state.suspensionModalData.userName}
            userType={this.state.suspensionModalData.userType}
            statusText={this.state.suspensionModalData.statusText}
            reason={this.state.suspensionModalData.reason}
            message={this.state.suspensionModalData.message}
            decision={this.state.suspensionModalData.decision}
            onClose={() => this.setState({ suspensionModalData: null })}
          />
        )}
        <h1>Admin / Message</h1>
        <div className="c-hr"></div>
        <div className="conversation-info-header">
          <div className="c-subheader-info-panel">
            <div className="c-subheader-info-panel__primary u-uppercase">
              ID: {this.state.short_id}
            </div>
          </div>
          <div className="conversation-info-header__actions">
            {this.state.suspendData && (
              <button
                type="button"
                className={`c-btn c-btn--3 c-btn--small ${
                  this.state.suspendData.isSuspended ? "c-btn--teal" : "c-btn--red"
                }`}
                onClick={() =>
                  this.handleFetchunSuspendUser({
                    userId: this.state.suspendData.userId,
                    userName: this.state.suspendData.userName,
                    offenseDetailId: this.state.suspendData.offenseDetailId,
                    userType: this.state.suspendData.userType,
                    decision: this.state.suspendData.isSuspended
                      ? "unsuspended"
                      : "suspended",
                    reason: this.state.suspendData.reason,
                  })
                }
              >
                {this.state.suspendData.isSuspended ? "Undo Suspension" : "Suspend"}
              </button>
            )}
            <button
              type="button"
              className="c-btn c-btn--3 c-btn--small"
              onClick={() => {
                sessionStorage.setItem("isBackNavigation", "true");
                sessionStorage.setItem(
                  "messagesRestoreState",
                  JSON.stringify({
                    selectedFilter: this.extraAttributes.selectedFilter,
                    selectedPage: this.extraAttributes.selectedPage,
                    selectedPageSize: this.extraAttributes.selectedPageSize,
                  })
                );
                toScreen(
                  false,
                  this.props.navigate,
                  this.extraAttributes.previousPath,
                  false,
                  {}
                );
              }}
            >
              Back
            </button>
          </div>
        </div>

        {this.extraAttributes.userShortId1 === "admin" && (
          <div className="l-row">
            <div className="l-col-66">
              <div className="c-input-wide">
                <form action="">
                  <textarea
                    rows="4"
                    className="c-input-wide__textarea"
                    value={this.state.newMessage}
                    onChange={this.handleInputChange}
                    name="newMessage"
                    placeholder="Write your message..."
                  ></textarea>
                </form>
              </div>
            </div>
            <div className="l-col-33">
              <div>
                <button
                  className="c-btn c-btn--small c-btn--full-width u-margin-bottom-xs"
                  onClick={(e) => this.sendMessage(e)}
                >
                  Send
                </button>
                <button
                  className="c-btn c-btn--small c-btn--full-width c-btn--3"
                  onClick={(e) => this.discardMessage(e)}
                >
                  Discard
                </button>
              </div>
            </div>
          </div>
        )}
        {this.renderPaginaiton()}
        <div className="conversation-body msger">
          <div
            class={`conversation-section ${this.extraAttributes.userShortId1 !== "admin" &&
              "user-conversation-section"
              }`}
          >
            {this.state.conversation.length > 0
              ? Object.keys(this.state.conversation)?.map(this.renderMessages)
              : (this.state.conversation.length !== undefined ||
                this.state.conversation) && (
                <span className="error-text">No conversations found</span>
              )}
          </div>
        </div>
        {this.renderPaginaiton()}
      </div>
    );
  }
}

Message.contextTypes = {
  router: PropTypes.object,
};

Message.propTypes = {
  userDetails: PropTypes.object.isRequired,
  userId: PropTypes.string.isRequired,
  updateState: PropTypes.func.isRequired,
};

export default withNavigate(Message);
